import { Component, ElementRef, HostListener, inject, Input, viewChild } from '@angular/core';
import { NotificationBadgeComponent } from '@sb/ui/badge';

import { EmployeeModel } from '../../../../reducers/orm/employee/employee.model';
import { SBHeaderService } from '../sb-header.service';
import { SBAvatarComponent } from './../../../../shared/sb-lib/avatar/sb-avatar.component';

@Component({
  selector: 'sb-header-avatar',
  imports: [SBAvatarComponent, NotificationBadgeComponent],
  template: `<div
    #root
    class="group flex h-full w-[50px] cursor-pointer items-center justify-center"
    (click)="headerService.toggleProfileDropdownOpen()"
  >
    <div class="relative rounded-full p-1 group-hover:bg-hover">
      <sb-legacy-avatar [employee]="employee" [size]="size"> </sb-legacy-avatar>
      @if (notificationCount > 0) {
        <sb-notification-badge
          class="absolute top-1 right-1 translate-x-1/2 -translate-y-1/2"
          [count]="notificationCount"
        />
      }
    </div>
  </div>`,
})
export class SBHeaderAvatarComponent {
  headerService = inject(SBHeaderService);

  @Input()
  employee: EmployeeModel;
  @Input()
  size: number;
  @Input()
  notificationCount: number;

  rootRef = viewChild.required<ElementRef<HTMLElement>>('root');

  @HostListener('document:click', ['$event'])
  clickout(clickEvent: Event) {
    const clickedNode = clickEvent.target instanceof Node ? clickEvent.target : null;

    if (!open || this.rootRef().nativeElement.contains(clickedNode)) {
      return;
    }

    this.headerService.profileDropdownOpen$.next(false);
  }
}
